const MAX_RECIPIENT_LENGTH = 64;
const MAX_DOMAIN_LENGTH = 253;
const MAX_EMAIL_LENGTH = MAX_RECIPIENT_LENGTH + 1 + MAX_DOMAIN_LENGTH;
const validEmailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(?:[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const stringIsBiggerThan = (len: number, ...strs: string[]) => {
  return strs.reduce((length, s) => length + s.length, 0) > len;
};

export function isValidEmail(email: string): boolean {
  if (!email || typeof email !== "string") return false;
  if (stringIsBiggerThan(MAX_EMAIL_LENGTH, email)) return false;

  const matchedEmail = validEmailRegex.exec(email);
  if (!matchedEmail) return false;

  return true;
}
